<script>

    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'

    export default {
        page: {
            title: 'Обращения',
            meta: [{ name: 'description', content: appConfig.description }],
        },

        components: { Layout, PageHeader },

        data() {
            return {
                title: 'Обращения',
                items: [
                    {
                        text: 'Личный кабинет',
                        href: '/account',
                    },
                    {
                        text: 'Обращения',
                        active: true,
                    },
                ],
                status: 'active',
                tableData: [],
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: null,
                sortDesc: false,
                fields: [
                    { key: 'select',   label: '', row:{'rowSelected':false}},
                    { key: 'customer', label: 'Клиент', sortable: true },
                    { key: 'qnt_messages', label: 'Кол-во сообщений', sortable: true },
                    { key: 'channel', label: 'Канал', sortable: true },
                    { key: 'last_activity_at', label: 'Последняя активность', sortable: true },
                    { key: 'created_at', label: 'Дата создания', sortable: true },
                    { key: 'status', label: 'Статус', sortable: true },
                ],
            }
        },

        computed: {
            rows() {
                return this.tableData.length ? this.tableData.length : 0
            },
             dialogs_list() {
                return this.$store.getters['dialogs/GET_DIALOGS_LIST'];
            },
            dialogs_table_data() {
                return this.$store.getters['dialogs/GET_DIALOGS_TABLE_DATA'];
            },
        },

        async mounted() {

            this.status = this.$route.params.status ? this.$route.params.status : this.status;

            let data_send = {};

            if(this.status !== ''){
                data_send = {
                    'status' : this.status
                }
            }

            await this.$store.dispatch('dialogs/FETCH_DIALOGS_LIST', data_send);
            this.tableData = this.dialogs_table_data;
            this.totalRows = this.items && this.items.length ? this.items.length : 0;
        },

        methods: {
            openForm(el){
                this.$router.push({ name: 'Dialogs.item', params: { dialog_uuid: el.uuid }});
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
        },

    }
</script>

<template>
	<Layout>

        <div class="row page-title align-items-center">
            <div class="col-sm-4 col-xl-6">
                <h4 class="mb-1 mt-0">{{ title }}</h4>
            </div>
        </div>

        <div class="col-12" style="margin-bottom: 20px; padding-left: 0;">
            <div class="btn-group">
                <router-link to="/account/dialogs" v-bind:class="[this.status === 'active' ? 'btn btn-primary' : 'btn btn-outline-primary']">
                    <i class="feather uil uil-comments-alt"></i> Активные
                </router-link>
                <router-link to="/account/dialogs/groups/archive"  v-bind:class="[this.status === 'archive' ? 'btn btn-primary' : 'btn btn-outline-primary']">
                    <i class="uil uil-archive-alt"></i> Архив
                </router-link>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="row" style="margin-top: 20px; margin-bottom: 5px">
                    <div class="col-sm-6 col-md-6">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Показывать&nbsp;
                                <b-form-select
                                    v-model="perPage"
                                    size="md"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;записей
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-6 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <label class="d-inline-flex align-items-center">
                                Поиск:
                                <b-form-input
                                    v-model="filter"
                                    type="search"
                                    @change="onFiltered()"
                                    placeholder="Введите текст..."
                                    class="form-control form-control-md ml-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>

                <div class="card">
                    <div class="card-body" style="padding-left: 0px; padding-right: 0px;">

                        <div class="table-responsive mb-0">
                            <b-table
                                :items="tableData"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                @filtered="onFiltered"
                                @row-clicked="openForm"                                
                            ></b-table>
                        </div>
                       
                    </div>
                </div>

                <div class="row" style="margin-bottom: 30px">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-left"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
	</Layout>
</template>
